var exports = {
  "nd": "panel-SXVjL",
  "JL": "svSquare-SXVjL",
  "FI": "svWhite-SXVjL",
  "v8": "svBlack-SXVjL",
  "M": "svHandle-SXVjL",
  "Ib": "sliderRow-SXVjL",
  "zn": "sliders-SXVjL",
  "w8": "eyedropperBtn-SXVjL",
  "Mx": "hiddenColorInput-SXVjL",
  "kn": "hueSlider-SXVjL",
  "Ys": "alphaSlider-SXVjL",
  "cg": "sliderHandle-SXVjL",
  "bd": "inputRow-SXVjL",
  "NB": "inputLabel-SXVjL",
  "Im": "hexInput-SXVjL",
  "mE": "rgbInput-SXVjL",
  "$r": "alphaInput-SXVjL",
  "JB": "percentSign-SXVjL",
  "zz": "swatches-SXVjL",
  "nf": "swatch-SXVjL",
};

module.exports = exports;
